import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { NoAuthNavBar } from 'stash/components/global/NoAuthNavBar';
import { postForgotPassword } from '../../actions/api/auth';
import { LoginDiv } from 'stash/components/log-in/LogInComponents';
import ForgotPasswordForm from './ForgotPasswordForm';

const mapDispatchToProps = (dispatch) => ({
	sendEmail: ({ email }) => {
		return dispatch(postForgotPassword({ email }))
			.then(() => {
				dispatch(push('/forgot-password/check-email'));
			})
			.catch((res) => {
				throw new Error(res.errors);
			});
	},
});

class ForgotPassword extends Component {
	render() {
		const { sendEmail } = this.props;
		return (
			<div>
				<NoAuthNavBar />
				<LoginDiv>
					<ForgotPasswordForm onSubmit={sendEmail} />
					{this.props.children}
				</LoginDiv>
			</div>
		);
	}
}

ForgotPassword.propTypes = {
	sendEmail: PropTypes.string,
	children: PropTypes.any,
};

export default connect(null, mapDispatchToProps)(ForgotPassword);
